import React from 'react';

interface TouchControlsProps {
  moveLeft: () => void;
  moveRight: () => void;
  rotate: () => void;
  softDrop: () => void;
  hardDrop: () => void;
}

// Overlay touch controls for mobile gameplay
const TouchControls: React.FC<TouchControlsProps> = ({ moveLeft, moveRight, rotate, softDrop, hardDrop }) => {
  return (
    <div className="touch-controls">
      <button onClick={moveLeft}>◀</button>
      <button onClick={rotate}>⟳</button>
      <button onClick={hardDrop}>⇓</button>
      <button onClick={softDrop}>↓</button>
      <button onClick={moveRight}>▶</button>
    </div>
  );
};

export default React.memo(TouchControls);